import i18n from '@/i18n/index.js'

const BASE_URL = import.meta.env.VITE_APP_API_URL

const getCookie = name => {
    const cookie = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${name}=`))

    return cookie ? decodeURIComponent(cookie.split('=').slice(1).join('=')) : null
}

const resolveUrl = url => {
    const resolvedUrl = new URL(url, BASE_URL || window.location.origin)
    const locale = i18n.global.locale

    resolvedUrl.searchParams.set(
      'lang',
      typeof locale === 'string' ? locale : locale.value
    )

    return resolvedUrl.toString()
}

const parseResponse = async response => {
    if (response.status === 204) return null

    const contentType = response.headers.get('content-type') || ''
    const text = await response.text()

    if (!text) return null
    if (contentType.includes('application/json')) return JSON.parse(text)

    return text
}

const request = async (method, url, payload) => {
    const headers = new Headers({Accept: 'application/json'})
    const xsrfToken = getCookie('XSRF-TOKEN')
    const options = {
        method,
        credentials: 'include',
        headers
    }

    if (xsrfToken) headers.set('X-XSRF-TOKEN', xsrfToken)

    if (payload instanceof FormData) {
        options.body = payload
    } else if (payload !== undefined) {
        headers.set('Content-Type', 'application/json')
        options.body = JSON.stringify(payload)
    }

    const response = await fetch(resolveUrl(url), options)
    const data = await parseResponse(response)

    if (!response.ok) {
        const error = new Error(response.statusText)
        error.response = {data, status: response.status}
        throw error
    }

    return {data}
}

const http = {
    get: url => request('GET', url),
    post: (url, payload) => request('POST', url, payload),
    put: (url, payload) => request('PUT', url, payload),
    delete: url => request('DELETE', url)
}

export {
    http
}
